import { render } from "./createcohortmodel.vue?vue&type=template&id=192fa9c9&scoped=true"
import script from "./createcohortmodel.js?vue&type=script&lang=js"
export * from "./createcohortmodel.js?vue&type=script&lang=js"

import "./createcohortmodel.vue?vue&type=style&index=0&id=192fa9c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192fa9c9"]])

export default __exports__